import React, { useState } from "react";
import { Box, Snackbar, Alert } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

import Hero from "./components/Hero";
// import ProgressCard from "./components/ProgressCard";
import Donate from "./components/Donate";
import Community from "./components/Community";
import Footer from "./components/Footer";
import Impact from "./components/Impact";
import StoryWizard from "./components/StoryWizard";
import { mockStats, mockDonations } from "./components/data/mockData";
import { CampaignStats } from "./components/types/index";

const DonationLanding: React.FC = () => {
  const [showStory, setShowStory] = useState(false);
  const [stats, setStats] = useState<CampaignStats>(mockStats);
  const [donationAmount, setDonationAmount] = useState(50);
  const [donorName, setDonorName] = useState("");
  const [donorMessage, setDonorMessage] = useState("");
  const [isDonating, setIsDonating] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // ✅ NEW: Donation handler
  const handleDonate = (e: React.FormEvent) => {
    e.preventDefault();
    if (isDonating) return;

    setIsDonating(true);

    setTimeout(() => {
      setStats((prev) => ({
        ...prev,
        totalRaised: prev.totalRaised + donationAmount,
        donorCount: prev.donorCount + 1,
      }));

      setIsDonating(false);
      setShowSuccess(true);
    }, 1000);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        pt: { xs: "88px", md: "88px" },
        color: "text.primary",
      }}
    >
      {/* ✅ Pass stats to Hero */}
      <Hero stats={stats} onOpenStory={() => setShowStory(true)} />

      {/* ✅ Pass donation logic into Donate */}
      <Donate
        donationAmount={donationAmount}
        setDonationAmount={setDonationAmount}
        isDonating={isDonating}
        onDonate={handleDonate}
        donorName={donorName}
        setDonorName={setDonorName}
        donorMessage={donorMessage}
        setDonorMessage={setDonorMessage}
      />

      <Community donations={mockDonations} loading={false} />
      <Impact />
      <Footer />

      <StoryWizard open={showStory} onClose={() => setShowStory(false)} />

      {/* ✅ Success Snackbar */}
      <Snackbar
        open={showSuccess}
        autoHideDuration={3000}
        onClose={() => setShowSuccess(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setShowSuccess(false)}
          severity="success"
          icon={<EmojiEventsIcon />}
          sx={{ fontWeight: 700, borderRadius: 50 }}
        >
          Thank you for your blessing!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DonationLanding;
